import React from 'react';
import { useNavigate } from 'react-router-dom';
import { ArrowRight } from 'lucide-react';

const PAGES = {
  '/': 'Dashboard', '/add-patient': 'Add Patient', '/assign-procedure': 'Assign Procedure', '/assign-informed-consent': 'Assign Informed Consent',
  '/assign-compliance-form': 'Assign Compliance Form', '/med-cards/assign': 'Assign Med Card', '/referral-management': 'Referral Management',
  '/assign-problems-emergencies': 'Assign Problems & Emergencies', '/practice/applicants': 'Hire Staff', '/procedure-library': 'Procedure Library',
  '/informed-consent-library': 'Informed Consents', '/compliance-forms-library': 'Compliance Forms Library', '/follow-up-settings': 'Check-In Settings',
  '/med-cards/library': 'Med Card Library', '/management-forms/library': 'Management Forms Library', '/problems-emergencies/library': 'Problems & Emergencies',
  '/tooth-guides': 'Tooth Guides', '/patient-ecards': 'Patient Education Studio', '/plans-billing': 'Plans & Billing', '/practice-settings': 'Practice Settings',
  '/practice-settings#baa': 'HIPAA Agreement', '/staff-management': 'Manage Staff Accounts', '/offices': 'Offices', '/dentist-management': 'Manage Dentists',
  '/referral-dentists': 'Referral Dentists', '/patient-management': 'Manage Patients', '/messages': 'Messages', '/reviews': 'Patient Reviews',
  '/newsletter': 'Patient Newsletter', '/newsletter/scheduler': 'Newsletter Scheduler', '/website-chatbot': 'Website Chatbot', '/smile-design': 'SmileDesign AI',
  'event:tutorials': 'Tutorials', 'event:getting-started': 'Getting Started', 'event:import-patients': 'Import Patients', 'event:dictate': 'Dictate Visit',
};
const EVENTS = { 'event:tutorials': 'practcom:open-tutorials', 'event:getting-started': 'practcom:open-welcome-checklist',
  'event:import-patients': 'practcom:open-import-patients', 'event:dictate': 'practcom:open-dictate' };

export const GotoButton = ({ action, onGo }) => {
  const navigate = useNavigate();
  const target = action.path;
  if (!PAGES[target]) return null;
  const go = () => {
    onGo?.();
    if (EVENTS[target]) {
      if (window.location.pathname !== '/') navigate('/');
      setTimeout(() => window.dispatchEvent(new Event(EVENTS[target])), window.location.pathname === '/' ? 0 : 600);
      return;
    }
    const [path, hash] = target.split('#');
    navigate(path);
    if (hash) setTimeout(() => document.getElementById(hash)?.scrollIntoView({ behavior: 'smooth' }), 1200);
  };
  return (
    <button type="button" onClick={go} className="mt-2 mr-2 inline-flex items-center gap-1.5 rounded-full bg-sky-700 hover:bg-sky-800 text-white text-xs font-semibold px-3 py-1.5"
      data-testid={`dr-g-goto-${target.replace(/[^a-z0-9]+/gi, '-')}`}>
      Take me to {action.label || PAGES[target]} <ArrowRight className="w-3.5 h-3.5" />
    </button>
  );
};

export const GOTO_TARGETS = Object.keys(PAGES);
